export default {
  activity: null,
  recordingButtonDisabled: false,
  dialpadVisible: false,
  notepadVisible: false,
  liveCoachChatVisible: false,
  isRepMuted: false,
  isCoachMuted: true
}



// WEBPACK FOOTER //
// ./src/store/modules/conference/state.js